import React, {Fragment, useId, useMemo} from 'react'
import PropTypes from 'prop-types'
import {Stack, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import InteractionStudioRecommendedProducts from '../../../components/interaction-studio/recommended-products'
import {MINIMUN_NUM_OF_RECOMMENDED_PRODUCTS, RECOMMENDED_ACCESSORIES_TYPE} from '../../../constants'
import lazyLoadable from '../../../utils/lazy-loadable'

const LazyRecommendedAccessoriesComponent = lazyLoadable(
    () => import('../../../components/recommended-accessories'),
    {
        ssr: false
    }
)

const RecommendedAccessories = ({containerRef, focusRef, product}) => {
    const recommendedProductsStyles = useMultiStyleConfig('RecommendedProducts')

    const id = useId()
    // precompute if there are accessories
    const hasRecommendedAccessories = useMemo(
        () =>
            product?.recommendations?.filter(
                ({recommendationType}) => recommendationType.value === RECOMMENDED_ACCESSORIES_TYPE
            )?.length >= MINIMUN_NUM_OF_RECOMMENDED_PRODUCTS,
        [product?.recommendations]
    )

    const productAsList = useMemo(() => [product], [product])

    if (!hasRecommendedAccessories) {
        return null
    }

    return (
        <Stack
            ref={containerRef}
            spacing={6}
            background="stokkeGray.bright"
            paddingTop={10}
            paddingBottom={12}
            px={{base: 4, lg: 8}}
        >
            <Text
                {...recommendedProductsStyles.title}
                as="h2"
                tabIndex="-1"
                ref={focusRef}
                id={id}
                // replicate the container padding top value to have the correct scrolling position
                scrollMarginTop={10}
            >
                <FormattedMessage
                    defaultMessage="Accessories"
                    id="product_detail.recommended_products.title.accessories"
                />
            </Text>
            <InteractionStudioRecommendedProducts id="is-pdp-accessories">
                <LazyRecommendedAccessoriesComponent
                    products={productAsList}
                    showTitle={false}
                    wrapper={Fragment}
                />
            </InteractionStudioRecommendedProducts>
        </Stack>
    )
}

RecommendedAccessories.propTypes = {
    containerRef: PropTypes.object,
    focusRef: PropTypes.object,
    product: PropTypes.object
}

export default RecommendedAccessories
